module.exports = __webpack_public_path__ + "img/gzjt3.0a6b21da.jpg";